import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import styled from '@mui/system/styled';
import { useNavTo } from '../nav';
import { Help, HelpFilled, HelpHover } from '../icons/nav/Help';
import Backdrop from '@mui/material/Backdrop';
import { useTranslate } from '@im/react-localization';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function HelpMenu(props) {
  var bottom = props.bottom,
    _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    height = props.height,
    left = props.left,
    marginTop = props.marginTop,
    navItems = props.navItems,
    width = props.width;
  var translate = useTranslate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHover = _useState4[0],
    setOnHover = _useState4[1];
  var navTo = useNavTo();
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDragged = _useState6[0],
    setIsDragged = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    anchorHelpEl = _useState8[0],
    setAnchorElHelp = _useState8[1];
  var fabRef = useRef(null);
  useEffect(function () {
    var sideNavMenu = document.querySelector('.sidenav-base-menulist');
    if (sideNavMenu) {
      sideNavMenu.style.marginBottom = "".concat(marginTop != null ? marginTop : 80, "px");
    }
  }, [marginTop]);
  var handleClose = function handleClose() {
    setAnchorElHelp(null);
    setOpen(!open);
  };
  var menuClick = function menuClick() {
    setOpen(!open);
  };
  var FabStyled = styled(Fab)(function (_ref) {
    var _theme$palette$common, _theme$palette$primar, _theme$palette$primar2, _theme$palette$common2;
    var theme = _ref.theme;
    return {
      '& : hover': {
        cursor: 'pointer'
      },
      ':hover': {
        background: open ? (_theme$palette$common = theme.palette.common) == null ? void 0 : _theme$palette$common.white : (_theme$palette$primar = theme.palette.primary) == null ? void 0 : _theme$palette$primar[50],
        color: (_theme$palette$primar2 = theme.palette.primary) == null ? void 0 : _theme$palette$primar2[50]
      },
      background: (_theme$palette$common2 = theme.palette.common) == null ? void 0 : _theme$palette$common2.white,
      borderRadius: 60,
      boxShadow: '0px 0px 16px rgba(51, 51, 51, 0.24)',
      height: height != null ? height : 72,
      padding: '8px',
      position: 'relative',
      width: width != null ? width : 72,
      zIndex: '9999 !important'
    };
  });
  var StyledHelpMenu = styled(Menu)(function (_ref2) {
    var theme = _ref2.theme;
    return {
      boxShadow: 'none',
      marginLeft: '6px',
      marginTop: isDragged ? undefined : '12px',
      zIndex: 9998
    };
  });
  var onDropEnd = function onDropEnd(event) {
    if (fabRef && fabRef.current) {
      fabRef.current.style.left = "".concat(event.clientX, "px");
      fabRef.current.style.top = "".concat(event.clientY, "px");
      fabRef.current.style.bottom = 'auto';
      fabRef.current.style.opacity = '1';
      setIsDragged(true);
    }
  };
  var onDragStart = function onDragStart() {
    if (fabRef && fabRef.current) {
      fabRef.current.style.opacity = '0';
    }
  };
  var renderIcons = function renderIcons() {
    if (open) {
      return /*#__PURE__*/_jsx(HelpFilled, {
        "data-testid": "".concat(testid, "-HelpFilledIcon")
      });
    }
    if (isHover) {
      return /*#__PURE__*/_jsx(HelpHover, {
        "data-testid": "".concat(testid, "-HelpHoverIcon")
      });
    }
    return /*#__PURE__*/_jsx(Help, {
      "data-testid": "".concat(testid, "-HelpIcon"),
      "data-element": "Help",
      "data-component": "renderIcons",
      "data-source-file": "HelpMenu.tsx"
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Box, {
      ref: fabRef,
      sx: {
        bottom: bottom != null ? bottom : 10,
        left: left != null ? left : 18,
        position: 'absolute'
      },
      "data-element": "Box",
      "data-source-file": "HelpMenu.tsx",
      children: [/*#__PURE__*/_jsx(Backdrop, {
        onClick: handleClose,
        open: open,
        sx: {
          backgroundColor: 'rgb(0 0 0 / 0.2)',
          color: '#bfbfbf',
          // this color does not exist in im-theme palette
          zIndex: function zIndex(theme) {
            return theme.zIndex.drawer + 1;
          }
        },
        "data-element": "Backdrop",
        "data-source-file": "HelpMenu.tsx"
      }), /*#__PURE__*/_jsx(FabStyled, {
        "aria-label": translate('Common.HelpIcon'),
        draggable: false,
        onClick: function onClick(e) {
          setAnchorElHelp(e.currentTarget);
          menuClick();
        },
        onDragEnd: function onDragEnd(e) {
          return onDropEnd(e);
        },
        onDragStart: onDragStart,
        onMouseEnter: function onMouseEnter() {
          return setOnHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setOnHover(false);
        },
        "data-element": "FabStyled",
        "data-source-file": "HelpMenu.tsx",
        children: renderIcons()
      })]
    }), anchorHelpEl && fabRef.current && /*#__PURE__*/_jsx(StyledHelpMenu, {
      TransitionComponent: Fade,
      anchorEl: fabRef.current,
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'bottom'
      },
      elevation: 3,
      id: "help-menu-items",
      marginThreshold: 24,
      onClose: handleClose,
      open: open,
      transformOrigin: {
        horizontal: 'left',
        vertical: 'bottom'
      },
      children: navItems && navItems.map(function (navItem, index) {
        return /*#__PURE__*/_jsx(StyledHelpMenuItem, {
          "data-testid": "".concat(testid, "-").concat(navItem.key),
          onClick: function onClick() {
            if (!navItem.navItems) {
              handleClose();
              navTo(navItem);
            }
          },
          children: /*#__PURE__*/_jsx(ListItemText, {
            primaryTypographyProps: {
              fontSize: '16px',
              lineHeight: '19px'
            },
            children: navItem.label
          })
        }, navItem.key);
      })
    })]
  });
}
var StyledHelpMenuItem = styled(MenuItem)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    '& .MuiListItemIcon-root': {
      minWidth: 20
    },
    color: theme.palette.primary.main,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    width: 'auto'
  };
});